module.exports = app => {
  const keywords = {};
  return keywords;
};
